import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "principle-candlesticks" }
const _hoisted_2 = { class: "principle-name" }
const _hoisted_3 = { class: "candlestick-track" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"chart-legend\" data-v-72611d4d><span class=\"legend-item\" data-v-72611d4d><span class=\"legend-line legend-green\" data-v-72611d4d></span> Good Persona </span><span class=\"legend-item\" data-v-72611d4d><span class=\"legend-dot\" data-v-72611d4d></span> Baseline </span><span class=\"legend-item\" data-v-72611d4d><span class=\"legend-line legend-red\" data-v-72611d4d></span> Bad Persona </span></div><div class=\"axis-header\" data-v-72611d4d><div class=\"axis-name-spacer\" data-v-72611d4d></div><div class=\"axis-scale\" data-v-72611d4d><span class=\"axis-tick\" style=\"left:0%;\" data-v-72611d4d>-1.0</span><span class=\"axis-tick\" style=\"left:25%;\" data-v-72611d4d>-0.5</span><span class=\"axis-tick\" style=\"left:50%;\" data-v-72611d4d>0.0</span><span class=\"axis-tick\" style=\"left:75%;\" data-v-72611d4d>+0.5</span><span class=\"axis-tick\" style=\"left:100%;\" data-v-72611d4d>+1.0</span></div></div>", 2)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principles, (p) => {
      return (_openBlock(), _createElementBlock("div", {
        key: p.id,
        class: "principle-row"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(p.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"gridline\" style=\"left:0%;\" data-v-72611d4d></div><div class=\"gridline\" style=\"left:25%;\" data-v-72611d4d></div><div class=\"gridline gridline-zero\" style=\"left:50%;\" data-v-72611d4d></div><div class=\"gridline\" style=\"left:75%;\" data-v-72611d4d></div><div class=\"gridline\" style=\"left:100%;\" data-v-72611d4d></div>", 5)),
          (_ctx.toLeft(p.bad) < _ctx.toLeft(p.baseline))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "range-line range-red",
                style: _normalizeStyle({ left: _ctx.toLeft(p.bad) + '%', width: (_ctx.toLeft(p.baseline) - _ctx.toLeft(p.bad)) + '%' })
              }, null, 4))
            : (_ctx.toLeft(p.bad) > _ctx.toLeft(p.baseline))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "range-line range-red",
                  style: _normalizeStyle({ left: _ctx.toLeft(p.baseline) + '%', width: (_ctx.toLeft(p.bad) - _ctx.toLeft(p.baseline)) + '%' })
                }, null, 4))
              : _createCommentVNode("", true),
          (_ctx.toLeft(p.bad) !== _ctx.toLeft(p.baseline))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "end-cap cap-red",
                style: _normalizeStyle({ left: _ctx.toLeft(p.bad) + '%' })
              }, null, 4))
            : _createCommentVNode("", true),
          (_ctx.toLeft(p.good) > _ctx.toLeft(p.baseline))
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "range-line range-green",
                style: _normalizeStyle({ left: _ctx.toLeft(p.baseline) + '%', width: (_ctx.toLeft(p.good) - _ctx.toLeft(p.baseline)) + '%' })
              }, null, 4))
            : (_ctx.toLeft(p.good) < _ctx.toLeft(p.baseline))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "range-line range-green",
                  style: _normalizeStyle({ left: _ctx.toLeft(p.good) + '%', width: (_ctx.toLeft(p.baseline) - _ctx.toLeft(p.good)) + '%' })
                }, null, 4))
              : _createCommentVNode("", true),
          (_ctx.toLeft(p.good) !== _ctx.toLeft(p.baseline))
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "end-cap cap-green",
                style: _normalizeStyle({ left: _ctx.toLeft(p.good) + '%' })
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "baseline-dot",
            style: _normalizeStyle({ left: _ctx.toLeft(p.baseline) + '%' })
          }, null, 4)
        ])
      ]))
    }), 128))
  ]))
}